var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItLabLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.45312,
    y: 88.59,
    width: 28.6397,
    height: 28.6397,
    transform: "rotate(-45 5.45312 88.59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.3384,
    y: 213.296,
    width: 28.6397,
    height: 28.6397,
    transform: "rotate(-45 68.3384 213.296)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.158,
    y: 25.7044,
    width: 28.6397,
    height: 28.6397,
    transform: "rotate(-45 130.158 25.7044)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3628,
    y: 119.5,
    width: 28.6397,
    height: 117.574,
    transform: "rotate(-45 36.3628 119.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7007,
    y: 182.432,
    width: 74,
    height: 28,
    transform: "rotate(-45 99.7007 182.432)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.547,
    y: 150.41,
    width: 28.6397,
    height: 28.6397,
    transform: "rotate(135 233.547 150.41)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.637,
    y: 119.5,
    width: 28.6397,
    height: 117.574,
    transform: "rotate(135 202.637 119.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.299,
    y: 56.5675,
    width: 74,
    height: 28,
    transform: "rotate(135 139.299 56.5675)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItLabLogoWhite);
export default __webpack_public_path__ + "static/media/it-lab_logo_white.220281a26cf56469e1dec786f03b2231.svg";
export { ForwardRef as ReactComponent };